import { MyComponent } from './client';
import { InfoSection } from './info';
import { useState } from 'react';
import { Link, useMatch } from 'react-router-dom';
import AnimatedPage from './AnimationLayout';

// Game and info live on one screen so the websocket in MyComponent stays
// connected while switching between them. /info just selects the info view.
export function MainScreen() {
  const isInfo = useMatch('/info') !== null;

  //turn off the button if we tell the site to
  const [showButton] = useState(
    () => new URLSearchParams(window.location.search).get('showbutton') !== 'false',
  );

  const cornerButton = (to, label) => (
    <div id='cornerButton' style={showButton ? undefined : { visibility: 'hidden' }}>
      <Link to={to} id='buttonText'>
        {label}
      </Link>
    </div>
  );

  return (
    <div id='full'>
      <AnimatedPage visible={!isInfo}>
        {cornerButton('/info', 'ABOUT')}
        <MyComponent></MyComponent>
      </AnimatedPage>
      <AnimatedPage visible={isInfo}>
        {cornerButton('/', 'GAME')}
        <InfoSection></InfoSection>
      </AnimatedPage>
    </div>
  );
}
